import Utility from "../Utility";
import {procedureTypeEnum, runProcedureInEnum} from "../serverClientShared/sharedEnums";
import {isIOS, isMacOs, isWindows} from "react-device-detect";
const isAndroid = Utility.isAndroid();
const isMoblie = Utility.isMobile();

export default class ProcedureUtility {

    static isDigitalTwin = procedure => procedure && procedure.ProcedureType === procedureTypeEnum.FUSION;
    static isFldt = procedure => this.isDigitalTwin(procedure) && !!procedure.FLDT;
    
    static isMedia = procedure => 
        procedure && this.#checkProcedureType(procedure, procedureTypeEnum.MEDIA, procedureTypeEnum.DESIGNER);

    static isLink = procedure => procedure && procedure.ProcedureType === procedureTypeEnum.LINK;

    static isSitePrep = procedure => procedure && procedure.ProcedureType === procedureTypeEnum.SITE_PREP;
    
    /**
     * 
     * @deprecated virtual room is legacy system, we do not have it since we added Immersive Room to our system. Use for backward compatibility purposes only.
     */
    static isVirtualRoom = procedure => procedure && procedure.ProcedureType === procedureTypeEnum.VIRTUAL_ROOM;

    static canRunOnThisDevice = procedure => procedure && (
        procedure.FLDT ||
        this.#canOpenInWindows(procedure) ||
        this.#canOpenInMac(procedure) ||
        this.#canOpenInAndroid(procedure) ||
        this.#canOpenInIOS(procedure)
    );
    
    static is3dFileAttached = procedure => procedure && (
        procedure.FLDT ||
        procedure.ThreeDFilesAndroid ||
        procedure.ThreeDFilesHololens ||
        procedure.ThreeDFilesIOs ||
        procedure.ThreeDFilesWebgl ||
        procedure.ThreeDFilesWin ||
        procedure.ThreeDFilesOsx
    );

    static isDesktopDigitalTwin = procedure => procedure && (
        procedure.FLDT || 
        this.#canOpenInWindows(procedure) || 
        this.#canOpenInMac(procedure)
    );

    static getWeb3dFile = procedure => procedure ? procedure.FLDT ?? procedure.ThreeDFilesWebgl : null;

    static supportedByWebGlPlayer = procedure => !isMoblie && !!this.getWeb3dFile(procedure);

    static canUpload3dFiles = procedure => procedure && !procedure.FLDT && this.#checkProcedureType(
        procedure,
        procedureTypeEnum.FUSION, 
        procedureTypeEnum.SITE_PREP, 
        procedureTypeEnum.VIRTUAL_CLASS_ROOM
    );

    static #checkProcedureType = (procedure, ...types) => types.includes(procedure.ProcedureType);
    static #canOpenInWindows = procedure => isWindows && procedure.ThreeDFilesWin;
    static #canOpenInMac = procedure => isMacOs && procedure.ThreeDFilesOsx;
    static #canOpenInAndroid = procedure => isAndroid && procedure.ThreeDFilesAndroid;
    static #canOpenInIOS = procedure => isIOS && procedure.ThreeDFilesIOs;
    static #canOpenInHololens = procedure => procedure.ThreeDFilesHololens;
    static #canOpenInWebGL = procedure => procedure.ThreeDFilesWebgl;

    static checkIfWebOnlyLink(procedure, projectProceduresMap) {
        if (projectProceduresMap && procedure && procedure.AllowRun === runProcedureInEnum.THREE_D) {
            const threeDModels = new Map(
                [...projectProceduresMap].filter(([key, model]) => (model.ProcedureType === procedureTypeEnum.FUSION || model.ProcedureType === procedureTypeEnum.THREE_D))
            );
            const threeDModelsConnected = procedure?.ThreeDModelsConnected || [];
            let undefinedCount = 0;
            for (const modelId of threeDModelsConnected) {
                const model = threeDModels.get(modelId);
                if (model && model.ThreeDFilesWebgl) {
                    return true
                } else if (!model) {
                    undefinedCount++;
                }
            }
            if (undefinedCount < threeDModelsConnected.length) {
                return false
            }
        }
        if (procedure.ProcedureType === procedureTypeEnum.FUSION && !procedure.ThreeDFilesWebgl) {
            return false
        }
        return true
    }
}